<template>
  <v-layout justify-space-between>
    <v-card
      class="custom-card mr-2"
      flat
      color="grey lighten-3"
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">TOTAL DE ENVIOS</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ folders.length }}</strong>
      </v-card-text>
    </v-card>
    <v-card
      class="custom-card received mr-2"
      flat
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">RECEBIDOS</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ received.length }}</strong>
      </v-card-text>
    </v-card>
    <v-card
      class="custom-card denied mr-2"
      flat
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">RECUSADOS</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ denied.length }}</strong>
      </v-card-text>
    </v-card>
    <v-card
      class="custom-card waiting mr-2"
      flat
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">AGUARDANDO</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ waiting.length }}</strong>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: 'sent-cards',
  props: ['folders'],
  computed: {
    received() {
      const received = this.folders.filter(item => item.received_status === 'Recebido');
      return received;
    },
    waiting() {
      const waiting = this.folders.filter(item => item.received_status === 'Não Recebido');
      return waiting;
    },
    denied() {
      const denied = this.folders.filter(item => item.received_status === 'Recusado');
      return denied;
    },
  },
};
</script>

<style scoped>
  .custom-card {
    border-radius: 5px;
  }
  .custom-title{
    font-size: 12px;
  }
  .amount {
    font-size: 32px;
  }
  .received {
    border: 1px solid #4caf50;
    color: #4caf50;
  }
  .denied {
    border: 1px solid #db4337;
    color: #db4337;
  }
  .waiting {
    border: 1px solid rgba(0, 0, 0, 0.54);
    color: rgba(0, 0, 0, 0.54);
  }
</style>



// WEBPACK FOOTER //
// src/views/folder/list/sent/SentCards.vue